// Lightweight analytics client — fires events to /api/analytics/event
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SESSION_KEY = "scr_session_id";

const getSessionId = () => {
  try {
    let id = localStorage.getItem(SESSION_KEY);
    if (!id) {
      id = `s_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
};

const safeReferrer = () => {
  try {
    return document.referrer && !document.referrer.includes(window.location.host)
      ? document.referrer.slice(0, 500)
      : null;
  } catch {
    return null;
  }
};

export const trackEvent = (event_type, meta = null, path = null) => {
  try {
    const body = {
      event_type,
      path: path || window.location.pathname + window.location.search,
      session_id: getSessionId(),
      referrer: safeReferrer(),
      meta: meta && typeof meta === "object" ? meta : null,
    };
    // Use keepalive so the request survives page unload too
    if (navigator.sendBeacon) {
      const blob = new Blob([JSON.stringify(body)], { type: "application/json" });
      navigator.sendBeacon(`${API}/analytics/event`, blob);
      return;
    }
    axios.post(`${API}/analytics/event`, body).catch(() => {});
  } catch {
    /* swallow — analytics must never break the app */
  }
};

export const trackPageView = (path) => trackEvent("page_view", null, path);
